(function () {
    'use strict';

    angular
        .module('bcmModule')
        .controller('bcmBiaProfileCoordinatorsController', Controller);

    Controller.$inject = ['$scope', '$timeout', '$state', 'esbEmployeeService', 'pagerService'];

    function Controller($scope, $timeout, $state, searchService, pagerService) {

        if (_.isUndefined($scope.ctrlCtxt)) $scope.ctrlCtxt = {};

        $scope.availableCoordinators = [];

        // Init Pager
        $scope.pager = pagerService.newPager({ numberOfItemsPerPage: 6 });
        $scope.pager.updatePagerFromItems($scope.availableCoordinators);

        // Search Coordinators
        $scope.searchCoordinators = function () {
            var searchTerm = $scope.ctrlCtxt.searchTerm;
            if (_.isUndefined(searchTerm) || searchTerm.length < 2) {
                $scope.availableCoordinators = [];
                $scope.pager.updatePagerFromItems($scope.availableCoordinators);
                return;
            }

            searchService
                .searchEmployees(searchTerm)
                .then(function (foundPersons) {
                    $scope.availableCoordinators = _.differenceBy(foundPersons, $scope.boxModel.BusinessContinuityCoordinators, 'ItemPersonID');
                    $scope.pager.updatePagerFromItems($scope.availableCoordinators);
                });
        };

        // Select Coordinator
        $scope.selectCoordinator = function (coord) {
            if (_.isUndefined($scope.boxModel.BusinessContinuityCoordinators)) $scope.boxModel.BusinessContinuityCoordinators = [];

            $scope.boxModel.BusinessContinuityCoordinators.push(coord);
            $scope.availableCoordinators = _.reject($scope.availableCoordinators, { ItemPersonID: coord.ItemPersonID });
        };

        // Remove Coordinator
        $scope.removeCoordinator = function (coord) {
            $scope.boxModel.BusinessContinuityCoordinators = _.reject($scope.boxModel.BusinessContinuityCoordinators, {
                ItemPersonID: coord.ItemPersonID
            });
        };
    }
})();